import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { FulfillmentPod, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { isGenericProduct } from '../../utils';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductStore = ({ checkGeneric, className }) => {
  const {
    product,
    itemId,
    isScheduleAMeasureEligible,
    onCheckNearbyStoresClick,
    storeId,
  } = useContext(ProductPodContext);

  const { channel } = useContext(ExperienceContext);
  if ((checkGeneric && isGenericProduct(product)) || isScheduleAMeasureEligible) return null;
  const storeClasses = classNames('product-pod__fulfillment--store', className, {
    'product-pod__fulfillment--store--mobile': channel === 'mobile'
  });

  return (
    <FulfillmentPod className={storeClasses}>
      <FulfillmentPodStore
        itemId={itemId}
        storeId={storeId}
        onCheckNearbyStoresClick={onCheckNearbyStoresClick}
      />
    </FulfillmentPod>
  );
};

ProductStore.propTypes = {
  checkGeneric: bool,
  className: string
};

ProductStore.defaultProps = {
  checkGeneric: false,
  className: null
};

ProductStore.displayName = 'ProductStore';
